// extracted by mini-css-extract-plugin
export default {"relativ":"Eltern_relativ__hF-E9","buttonbild":"Eltern_buttonbild__2doqI"};